import Vue from 'vue'
import i18n from '@/locales'

const menuLocalName = Vue.filter('menuLocalName', function (menuInfo) {
  return menuInfo.menuName[i18n.locale] || menuInfo.tab
})

export default menuLocalName
